import $ from "jquery";
import "jquery-match-height";

$(function () {
  $(window).on("load resize", function () {
    $(".js-matchHeight").matchHeight();
  });

  // タブのクリックイベント発生時にmatchHeightを再適用
  $(".p-top-topics__category li").on("click", function () {
    // タブが切り替わった後にmatchHeightを適用
    setTimeout(function () {
      $(".js-matchHeight").matchHeight();
    }, 0); // タイミングを少し遅らせることで、正しく高さが適用されるように調整
  });
});
/*!
 * jquery-match-height 0.7.2 by @liabru
 * http://brm.io/jquery-match-height/
 * License: MIT
 */
